import React from 'react';
import './Blog.css';

import { extractDateParts } from '../../utils'; // Utility function to extract date parts

import { FaTags, FaUserCircle } from 'react-icons/fa'; // Importing icons

import { Link } from 'react-router-dom'; // Importing Link for navigation




const Blog = ({ blog }) => {

  const { id, image, date, heading, admin, category } = blog; // Extracting data from blog
  const { day, shortMonth } = extractDateParts(date); // Extracting formatted date parts using utility function

  return (
    <div className='blog-item' key={id}>

      <div className='image'>
        <img src={image} alt={heading} /> {/* Blog image */}
        <div className='date'><span>{day}</span> {shortMonth}</div> {/* Blog Date */}
      </div>

      <div className='content'>

        <div className='details'>

          {/* Blog Admin */}
          <h3>
            <div className='icon'><FaUserCircle /></div>
            <span>By {admin}</span>
          </h3>

          {/* Blog Category */}
          <h3>
            <div className='icon'><FaTags /></div>
            <Link className='category' to={`/Blogs/category/${category}`}>{category}</Link>
          </h3>

        </div>

        {/* Blog Title with dynamic navigation */}
        <Link
          to={{
            pathname: '/Blogs/' + heading,
          }}
          state={blog}
          className='main-heading'>
          {heading}
        </Link>

        <p>{blog.content}</p> {/* Blog Description */}

      </div>

    </div>
  );
};

export default Blog;